import '@ui5/webcomponents-icons/dist/feedback.js';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';

import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, signal} from '@angular/core';
import {Router} from '@angular/router';
import {PxSurveyService} from '@app/services/px-survey/px-survey.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'dcp-px-survey-widget',
  templateUrl: './px-survey-widget.component.html',
  styleUrls: ['./px-survey-widget.component.scss'],
  standalone: true,
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PxSurveyWidgetComponent implements OnInit {
  private readonly pxSurveyService = inject(PxSurveyService);
  private readonly router = inject(Router);
  private readonly breakpointObserver = inject(BreakpointObserver);

  public isIconOnly = signal(false);
  public ngOnInit(): void {
    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small])
      .pipe(untilDestroyed(this))
      .subscribe((result) => {
        this.isIconOnly.set(result.matches);
      });
  }

  public openSurvey() {
    this.pxSurveyService.startSurvey();
  }

  public shouldShowWidget(): boolean {
    return this.router.url?.match(/(cart)|(checkout)|(configure)/)?.length > 0;
  }
}
